<template>
 <div>
      <van-uploader :after-read="afterRead" multiple  v-model="fileList" />
  <van-button @click="uplod">上传</van-button>
 </div>
</template>

<script>
export default {
     data() {
    return {
      fileList: [
      
      ],
    };
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    uplod(){
       console.log(this.fileList)
    },
  },
}
</script>

<style>

</style>